import React, { createContext, useContext, useState } from "react";

const AdminUsersListContext = createContext();

export const AdminUsersListProvider = ({ children }) => {
  const [message, setMessage] = useState("Esto un mensaje de prueba");
  const [alertType, setAlertType] = useState("success");

  //Gestion del Alert del Header
  const [showAlertHeader, setShowAlertHeader] = useState(false);
  const openAlertHeader = () => {
    setShowAlertHeader(true);
  };
  const closeAlertHeader = () => {
    setShowAlertHeader(false);
  };

  const [showNewUserModal, setShowNewUserModal] = useState(false);
  const openNewUserModal = () => {
    setShowNewUserModal(true);
  };

  const closeNewUserModal = () => {
    setShowNewUserModal(false);
  };

  const [selectedUser, setSelectedUser] = useState(null);

  const [showChangeUserPropertiesModal, setChangeUserPropertiesModal] =
    useState(false);
  const openChangeUserPropertiesModal = (user) => {
    setSelectedUser(user);
    setChangeUserPropertiesModal(true);
  };

  const closeChangeUserPropertiesModal = () => {
    setChangeUserPropertiesModal(false);
  };

  const [showChangeUserRoleModal, setShowChangeUserRoleModal] = useState(false);
  const openChangeUserRoleModal = (user) => {
    setSelectedUser(user);
    setShowChangeUserRoleModal(true);
  };
  const closeChangeUserRoleModal = () => setShowChangeUserRoleModal(false);

  return (
    <AdminUsersListContext.Provider
      value={{
        setMessage,
        setAlertType,
        openAlertHeader,
        closeAlertHeader,
        openNewUserModal,
        closeNewUserModal,
        showNewUserModal,
        selectedUser,
        showChangeUserPropertiesModal,
        openChangeUserPropertiesModal,
        closeChangeUserPropertiesModal,
        showChangeUserRoleModal,
        openChangeUserRoleModal,
        closeChangeUserRoleModal,
      }}
    >
      {children}
    </AdminUsersListContext.Provider>
  );
};

export const useAdminUsersListContext = () => {
  return useContext(AdminUsersListContext);
};
